"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PreloadLink = exports.PreloadLinkState = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.define-property");

require("regenerator-runtime/runtime");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.regexp.match");

require("core-js/modules/es6.regexp.replace");

var _pick2 = _interopRequireDefault(require("lodash/fp/pick"));

var _last2 = _interopRequireDefault(require("lodash/fp/last"));

var _isUndefined2 = _interopRequireDefault(require("lodash/fp/isUndefined"));

var _isEmpty2 = _interopRequireDefault(require("lodash/fp/isEmpty"));

var _SystemContext = require("../../SystemContext");

var _found = require("found");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactRelay = require("react-relay");

var _unstated = require("unstated");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PreloadLinkState =
/*#__PURE__*/
function (_Container) {
  _inherits(PreloadLinkState, _Container);

  function PreloadLinkState() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, PreloadLinkState);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(PreloadLinkState)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isLoading: false
    });

    _defineProperty(_assertThisInitialized(_this), "toggleLoading", function (isLoading) {
      _this.setState({
        isLoading: isLoading
      });
    });

    return _this;
  }

  return PreloadLinkState;
}(_unstated.Container);

exports.PreloadLinkState = PreloadLinkState;

var _PreloadLink = function _PreloadLink(preloadLinkProps) {
  /**
   * Create a Preloader wrapper to perform relay fetches and render out a <Link>
   */
  var Preloader =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(Preloader, _React$Component);

    function Preloader() {
      var _getPrototypeOf3;

      var _this2;

      _classCallCheck(this, Preloader);

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      _this2 = _possibleConstructorReturn(this, (_getPrototypeOf3 = _getPrototypeOf(Preloader)).call.apply(_getPrototypeOf3, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_this2), "handleClick", function (event) {
        event.preventDefault();

        if (_this2.props.onClick) {
          _this2.props.onClick();
        }

        _this2.props.onToggleLoading(true);

        _this2.fetchData().then(function () {
          var _this2$props = _this2.props,
              router = _this2$props.router,
              replace = _this2$props.replace,
              to = _this2$props.to;

          _this2.props.onToggleLoading(false);

          if (replace) {
            router.replace(replace);
          } else {
            router.push(to);
          }
        });
      });

      return _this2;
    }

    _createClass(Preloader, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (this.props.immediate) {
          this.fetchData();
        }
      }
      /**
       * For a given route, check to see if it has a Relay query attached.
       *
       * @example
       *
       * Given this link:
       * <PreloadLink to='/home'>Home</PreloadLink>
       *
       * Preloader will iterate over the route config and look for a match and
       * return its `query` value:
       *
       * const routes = [
       *   {
       *     path: '/home',
       *     Component: () => <div>Home!</div>
       *     query: ...
       *   }
       * ]
       */

    }, {
      key: "getRouteQuery",
      value: function getRouteQuery() {
        var _this$props = this.props,
            resolver = _this$props.resolver,
            relayEnvironment = _this$props.relayEnvironment,
            router = _this$props.router,
            to = _this$props.to;
        var getRouteMatches = _found.ResolverUtils.getRouteMatches,
            getRouteValues = _found.ResolverUtils.getRouteValues;
        var location = router.createLocation(to);
        var match = router.matcher.match(location); // Route is missing query, just pass through

        if (!match) {
          return;
        }

        var routes = router.matcher.getRoutes(match);

        var augmentedMatch = _objectSpread({}, match, {
          routes: routes
        });

        var routeMatches = getRouteMatches(augmentedMatch); // FIXME: This should result in a GraphQLTaggedNode type

        var query = (0, _last2.default)(getRouteValues(routeMatches, function (route) {
          return route.getQuery;
        }, function (route) {
          return route.query;
        }).filter(function (q) {
          return !(0, _isUndefined2.default)(q);
        }));
        var cacheConfig = (0, _last2.default)(getRouteValues(routeMatches, function (route) {
          return route.getCacheConfig;
        }, function (route) {
          return route.cacheConfig;
        }).filter(function (caches) {
          return !(0, _isUndefined2.default)(caches);
        }));
        var variables = (0, _last2.default)(resolver.getRouteVariables(match, routeMatches).filter(function (routeVariables) {
          return !(0, _isUndefined2.default)(routeVariables) && !(0, _isEmpty2.default)(routeVariables);
        }));
        return {
          environment: relayEnvironment,
          query: query,
          cacheConfig: cacheConfig,
          variables: variables
        };
      }
    }, {
      key: "fetchData",
      value: function fetchData() {
        var _this3 = this;

        return new Promise(
        /*#__PURE__*/
        function () {
          var _ref = _asyncToGenerator(
          /*#__PURE__*/
          regeneratorRuntime.mark(function _callee(resolve, reject) {
            var routeQuery, requirementsMet, environment, query, variables, cacheConfig;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    routeQuery = _this3.getRouteQuery();
                    requirementsMet = routeQuery && routeQuery.environment && routeQuery.query;

                    if (requirementsMet) {
                      _context.next = 5;
                      break;
                    }

                    console.warn("Attempting to use PreloadLink but relayEnvironment or " + "query is missing.", _this3.props);
                    return _context.abrupt("return", resolve());

                  case 5:
                    environment = routeQuery.environment, query = routeQuery.query, variables = routeQuery.variables, cacheConfig = routeQuery.cacheConfig;
                    _context.prev = 6;
                    _context.next = 9;
                    return (0, _reactRelay.fetchQuery)(environment, query, variables, cacheConfig);

                  case 9:
                    resolve(); // FIXME: Handle fetch errors
                    // router.push('/404')

                    _context.next = 15;
                    break;

                  case 12:
                    _context.prev = 12;
                    _context.t0 = _context["catch"](6);
                    console.error("[Reaction Router/PreloadLink]", _context.t0);

                  case 15:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, null, [[6, 12]]);
          }));

          return function (_x, _x2) {
            return _ref.apply(this, arguments);
          };
        }());
      }
    }, {
      key: "render",
      value: function render() {
        // Only pass found-router specific props across
        var whitelistedProps = (0, _pick2.default)(["Component", "activeClassName", "exact", "replace", "to"], this.props);
        return _react.default.createElement(_found.Link, _extends({}, whitelistedProps, {
          onClick: this.handleClick
        }), this.props.children);
      }
    }]);

    return Preloader;
  }(_react.default.Component);
  /**
   * Subscribe to PreloadLink state
   */


  _defineProperty(Preloader, "propTypes", {
    /**
     * Load route query data transparently in the background on mount
     */
    immediate: _propTypes.default.bool,

    /**
     * Route to transition to. Uses history.pushState
     */
    to: _propTypes.default.string,

    /**
     * Route to transition to. Uses history.replaceState. Note that `replace`
     * and `to` are mutually exclusive.
     */
    replace: _propTypes.default.string,

    /**
     * Class to add when the link's to / replace route matches current URL
     */
    activeClassName: _propTypes.default.string,

    /**
     * State handler to toggle fetching
     */
    onToggleFetching: _propTypes.default.func.isRequired,

    /**
     * Injected props from ContextConsumer
     */
    relayEnvironment: _propTypes.default.object.isRequired,
    routes: _propTypes.default.array.isRequired,
    resolver: _propTypes.default.object.isRequired
  });

  _defineProperty(Preloader, "defaultProps", {
    activeClassName: "active",
    immediate: false,
    onToggleFetching: function onToggleFetching(x) {
      return x;
    }
  });

  return _react.default.createElement(_SystemContext.ContextConsumer, null, function (context) {
    return _react.default.createElement(_unstated.Subscribe, {
      to: [PreloadLinkState]
    }, function (preloadLink) {
      return _react.default.createElement(Preloader, _extends({
        onToggleLoading: preloadLink.toggleLoading
      }, context, preloadLinkProps));
    });
  });
};

var PreloadLink = (0, _found.withRouter)((0, _SystemContext.withContext)(_PreloadLink));
exports.PreloadLink = PreloadLink;
//# sourceMappingURL=PreloadLink.js.map